import StyleSheet from '../../utils/helpers/styleSheet'
import AddCaptionButton from './buttons/AddCaptionButton'

const styles: StyleSheet = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    margin: '20px 20px',
  },
  imagesControls: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 15,
  },
  controlGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
  },
}

interface AddCaptionProps {
  isGraphics?: boolean
}

export default function AddCaption({isGraphics = false}: AddCaptionProps) {
  return (
    <div style={styles.container}>
      <div style={styles.controlGroup}>
        <div style={styles.imagesControls}>
          <AddCaptionButton singleLine={isGraphics} />
        </div>
      </div>
    </div>
  )
}
